import { styled } from 'styled-components';

export const LoadingStatesMediaPlaceholder = styled.div`
  align-items: center;
  background-color: #dedee1;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;

export const PlayerOrEquivalent = styled.div`
  grid-area: PlayerOrEquivalent;
  z-index: 1;
`;

export const PlayerOrPlaceholderContainer = styled.div<{ aspectRatio: number }>`
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
  max-height: 60vh;
  margin: 0 auto;
`;

export const PlayerAndTimelineContainer = styled.div``;

export const TabbedArea = styled.div<{ $isInRightColumn: boolean }>`
  background-color: ${({ $isInRightColumn }) => ($isInRightColumn ? 'white' : '')};
  border-radius: ${({ theme, $isInRightColumn }) =>
    $isInRightColumn ? theme.spacing.space04 : ''};
  box-shadow: ${({ theme, $isInRightColumn }) => ($isInRightColumn ? theme.shadow.elevation2 : '')};
  display: grid;
  grid-area: TabbedArea;
  grid-template-rows: auto minmax(0, 1fr);
  height: ${({ $isInRightColumn }) => ($isInRightColumn ? '100%' : '')};
  margin-bottom: 20px;
  overflow: ${({ $isInRightColumn }) => ($isInRightColumn ? 'hidden' : '')};
  padding: ${({ theme, $isInRightColumn }) => ($isInRightColumn ? theme.spacing.space04 : 0)}
    ${({ theme, $isInRightColumn }) =>
      $isInRightColumn ? theme.spacing.space04 : theme.spacing.space05};
  position: relative;
  z-index: 0;
`;

// Typical height of the `StickyTabBarWrapper` - used to calculate top offset for other
// sticky elements / update if this element's children are updated such that the height changes
export const STICKY_TAB_BAR_WRAPPER_HEIGHT = 46;

export const PlayerContainer = styled.div<{ $isPictureInPicture: boolean }>`
  box-shadow: ${({ $isPictureInPicture, theme }) =>
    $isPictureInPicture ? theme.shadow.elevation2 : ''};
`;
